import { Box, CircularProgress, Fade, Typography } from "@mui/material";
import { useContext } from "react";
import { ICandidateReview } from "../../../App/Typings/Candidate";
import { CandidateContext } from "../../CandidateProfile";
import { AddReview } from "./Subcomponents/AddReview/AddReview";
import Ratings from "./Subcomponents/Ratings";
import { Review } from "./Subcomponents/Reviews/Review";
import { useCandidateReviewsQuery } from "../../../App/Queries/ReviewQueries";

function sortReviews(reviews: ICandidateReview[]): ICandidateReview[] {
  return reviews.sort((a, b) => {
    return new Date(b.reviewDate).getTime() - new Date(a.reviewDate).getTime();
  });
}

export default function ProfileRatings() {
  const { candidate } = useContext(CandidateContext);
  const { data: response, isFetched } = useCandidateReviewsQuery(candidate.id);

  return isFetched ? (
    <Fade in={isFetched} timeout={500}>
      <Box sx={{ position: "relative" }}>
        <Box sx={{ display: "flex", gap: "2rem", alignItems: "center" }}>
          <Box>
            <Typography
              data-test={"candidate-header-ratingstext"}
              sx={{
                fontSize: "1rem",
                whiteSpace: "nowrap",
                color: "text.secondary",
                fontWeight: "600",
              }}
            >
              Overall Rating
            </Typography>
            <Ratings stars={response?.averageRating ?? 0} setStars={null} readOnly={true} />
          </Box>
          {response?.topReview.length && (
            <Typography
              data-test={"candidate-header-topreview"}
              sx={{
                color: "rgba(0,0,0,.6)",
                fontStyle: "italic",
              }}
            >
              <strong style={{ display: "block" }}>Top Review</strong>
              {response?.topReview}
            </Typography>
          )}
        </Box>
        <AddReview />
        <Box sx={{ mt: 5 }}>
          {(response?.reviews.length ?? 0) > 0 &&
            sortReviews(response?.reviews ?? []).map((review) => (
              <Review review={review} key={review.id}></Review>
            ))}
        </Box>
      </Box>
    </Fade>
  ) : (
    <Box sx={{ minHeight: 500, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <CircularProgress />
    </Box>
  );
}
